import React, { useContext } from 'react'
import styles from './UserHeader.module.css'
import { UserContext } from '../../context/UserContext'

const UserHeader: React.FC = () => {
  const context = useContext(UserContext)

  if (!context) {
    throw new Error('UserHeader must be used within a UserProvider')
  }

  const { currentUser } = context

  return (
    <section
      className={`w-full flex flex-row items-center justify-between max-w-screen-md mx-auto mb-2 px-5`}
    >
      <div>
        <div className={styles.circleIconWrapper}>
          <i className="text-white fas fa-user" style={{ fontSize: '21px' }}></i>
        </div>
      </div>
      <div className="mx-2">
        <p className="text-sm font-semibold leading-snug text-white uppercase">
          {currentUser?.last_name} {currentUser?.first_name} {currentUser?.middle_name}
        </p>
        <p className="text-sm font-normal leading-tight text-white uppercase">
          №&nbsp;ЧБ: {currentUser?.party_number}
        </p>
        {currentUser?.po_id && currentUser?.po_name ? (
          <p className="text-xs font-normal leading-tight text-white uppercase">
            {currentUser.po_name},&nbsp;POID: {currentUser.po_id}
          </p>
        ) : (
          <p className="text-xs font-normal leading-tight text-white uppercase">
            {currentUser?.mo_name && <span>{currentUser.mo_name},&nbsp;</span>}
            {currentUser?.mo_id && <span>MOID: {currentUser.mo_id}</span>}
          </p>
        )}
      </div>
      <div>
        <a
          href="https://t.me/ERcontributions_bot"
          target="_blank"
          className={styles.supportBtn}
          aria-label="Поддержка"
        >
          <i className="fas fa-user-headset text-primary" style={{ fontSize: '18px' }}></i>
        </a>
      </div>
    </section>
  )
}

export default UserHeader
